const factory = ({ publicKeyProvider }) => {
    return {
        publicKeyProvider: {
            mockXPub: publicKeyProvider.mockXPub,
            unmockXPub: publicKeyProvider.unmockXPub,
            clearAllMocks: publicKeyProvider.clearAllMocks,
        },
    };
};
const publicKeyProviderDebugDefinition = {
    id: 'publicKeyProviderDebug',
    type: 'debug',
    factory,
    dependencies: ['publicKeyProvider'],
    public: true,
};
export default publicKeyProviderDebugDefinition;
